<template>
  <Modal>
    <Modal.Body>
      <AddPaymentMethodBody :error-message="errorMessage" />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button variant="primary" :loading="loading" @click="handleSave">
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Button, useModal } from '@dacr/library'

import AddPaymentMethodBody from './AddPaymentMethodBody.vue'
import { useAddPaymentMethod } from '../useAddPaymentMethod'

const { close } = useModal()
const { loading, errorMessage, save } = useAddPaymentMethod()

const handleSave = async () => {
  if (await save()) close()
}
</script>
